import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type WarehouseDeliveryIntakesList as SchemaWarehouseDeliveryIntakesList } from '../schemas/WarehouseDeliveryIntakesList';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Получить список заборов для склада
 */
export const GetWarehouseDeliveryIntakesContentType = '' as const;
export type GetWarehouseDeliveryIntakesRequest = void;
export type GetWarehouseDeliveryIntakesResponses = LinkCommonErrorResponses & {
    /**
     * @description Список заборов для склада
     */
    '200': {
        'application/json': SchemaWarehouseDeliveryIntakesList;
    };
};
export type GetWarehouseDeliveryIntakesResponseSuccess =
    GetWarehouseDeliveryIntakesResponses['200']['application/json'];
export type GetWarehouseDeliveryIntakesSearchParams = {
    service_type: LinkDeliveryServiceType;
    page?: number;
    per_page?: number;
    sort_by: 'date';
    sort_order?: 'asc' | 'desc';
};
export type GetWarehouseDeliveryIntakesPathParameters = {
    warehouse_id: string;
};
export const GetWarehouseDeliveryIntakesUrl = '/warehouses/{warehouse_id}/delivery/intakes' as const;
export const GetWarehouseDeliveryIntakesMethod = 'GET' as const;
export const getGetWarehouseDeliveryIntakesUrl = (params: GetWarehouseDeliveryIntakesPathParameters) =>
    GetWarehouseDeliveryIntakesUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetWarehouseDeliveryIntakesPathParameters) => String(params[param])
    );
